var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8PreviewPane50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    baseProfile: "basic",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#12d9e3",
    d: "M41,8H7c-2.757,0-5,2.243-5,5v22c0,2.757,2.243,5,5,5h34c2.757,0,5-2.243,5-5V13 C46,10.243,43.757,8,41,8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#324561",
    d: "M24,35c-9.46,0-14.605-9.627-14.819-10.036c-0.152-0.291-0.152-0.637,0-0.928 C9.395,23.627,14.54,14,24,14s14.605,9.627,14.819,10.036c0.152,0.291,0.152,0.637,0,0.928C38.605,25.373,33.46,35,24,35z M11.221,24.5C12.335,26.339,16.863,33,24,33s11.665-6.661,12.779-8.5C35.665,22.661,31.137,16,24,16S12.335,22.661,11.221,24.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#324561",
    d: "M24,30c-3.032,0-5.5-2.468-5.5-5.5S20.968,19,24,19c0.375,0,0.748,0.038,1.109,0.112 c0.541,0.112,0.889,0.641,0.777,1.182c-0.112,0.541-0.645,0.885-1.182,0.777C24.477,21.023,24.239,21,24,21 c-1.93,0-3.5,1.57-3.5,3.5S22.07,28,24,28s3.5-1.57,3.5-3.5c0-0.373-0.059-0.742-0.174-1.096c-0.172-0.525,0.114-1.09,0.64-1.261 c0.529-0.173,1.09,0.115,1.261,0.64c0.182,0.555,0.273,1.132,0.273,1.717C29.5,27.532,27.032,30,24,30z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8PreviewPane50);
export default __webpack_public_path__ + "static/media/icons8-preview-pane-50.442d65b1bd358d56247a650417f2b78d.svg";
export { ForwardRef as ReactComponent };